export default __webpack_public_path__ + "static/media/maze-1.bc992b89.svg";